<template>
  <div class="ply">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
          <img v-if="URL_MAQIN==2" src="../assets/img/kjc返回.png" alt />
          <img v-if="URL_MAQIN==1" src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
          <el-breadcrumb-item>{{video_detail.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content_box clearfix">
        <!-- <div class="content_box_l">
          <div class="content_box_l_title">已购课程</div>
          <div class="class_list active">初级会计实务</div>
          <div class="class_list">经济法基础</div>
        </div>-->
        <div class="content_box_r">
          <div class="top_box clearfix">
            <div class="video">
              <div class="title">{{video_detail.title}}</div>
              <div id="J_prismPlayer" class="prism-player"></div>
              <!-- 广告位 -->
              <div class="billing" @click="billing_click(adInfo.link)" v-if="adInfo">
                <img :src="adInfo.content" alt />
              </div>
            </div>
            <!-- 目录 -->
            <div class="directory">
              <div class="directory_title">
                <span></span>课程目录
              </div>
              <div class="directory_content">

                <div
                  class="directory_box"
                  v-for="(item,index) in video_detail.knowledge_list"
                  :key="index"
                  @click="chuange_video(item.id,item)"
                >
                  <div
                    class="directory_list"
                    :class="$route.query.knowledge_id==item.id? 'active':'' "
                  >{{item.name}}</div>
                </div>

                


                
              </div>
            </div>
          </div>
          <!-- 提问sb哈哈哈哈-->
          <div class="put_box clearfix" v-show="false">
            <div class="put_sb">
              <div class="put_title clearfix">
                <span></span>
                提问
              </div>
              <div class="put_content clearfix">
                <el-input v-model="value" placeholder="请输入内容"></el-input>
                <div class="btn" @click="save_click">提交</div>
              </div>
            </div>
            <div class="put_sb_bottom">
              <div class="put_sb_bottom_box">
                <div class="put_sb_list clearfix" v-for="(item,index) in comment_list" :key="index">
                  <div class="put_sb_list_l">
                    <img
                      v-if="item.avatar==''"
                      src="https://www.mifengdao.com/views/super/skin/super/image/toux.png"
                      alt
                    />
                    <img v-else :src="item.avatar" alt />
                  </div>
                  <div class="put_sb_list_r">
                    <div class="name">{{item.username}}</div>
                    <div class="time">{{item.updated_at}}</div>
                    <div class="text">{{item.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    <!-- v3猜你喜欢 -->
    <div class="recommend" v-if="false">
      <div class="titleBox">猜你喜欢</div>
      <div class="content gundong">
        <a v-for="(item,index) in GuessList" :key="index" :href="item.buy_url">
          <div class="title">{{item.title}}</div>
          <div class="iconBox">
            <div class="icon" v-for="(item2,index2) in item.teacher" :key="index2">
              <img :src="item2.head_ico" alt="">
              <span>{{item2.name}}</span>
            </div>
          </div>
          <div class="bottomBox">
              <!-- 价格判断 -->
              <div class="price" v-if="item.bargain_info&&item.bargain_info.base_price">
                砍价¥{{item.bargain_info.base_price}}
              </div>
              <div class="price" v-else-if="item.collage_info&&item.collage_info.spell_price">
                拼团价¥{{item.collage_info.spell_price}}
              </div>
              <div class="price" v-else-if="item.ticket&&item.ticket.ticket_price">
                券后价¥{{item.ticket.ticket_price}}
              </div>
              <div class="price" v-else>
                {{item.sell_price===0?'免费':'¥'+item.sell_price}}
              </div>

              <div class="tip">已售{{item.sale}}人</div>
              <button>立即购买</button>
            </div>
        </a>
      </div>
    </div>

    <!-- 底部二 -->
    <div class="bottom2" v-if="!$route.query.isBack">
      <!-- <el-button class="left" @click="goJY" v-if="docDetails">查看讲义</el-button> -->
      <el-button class="right" @click="goTest">趁热练习</el-button>
    </div>
    <div class="bottom2" v-else>
      <el-button class="right" @click="$router.go(-1)">返回做题</el-button>
    </div>

    </div>
    <!-- 右下角加入我们组件 -->
    <right-down
      :type="URL_MAQIN==1?3:13"
      :title="addClassContent.title"
      :content="addClassContent.qrcode_thumb"
    ></right-down>




    




  </div>
</template>
<script>
import "../assets/js/aliplayercomponents-1.0.5.min.js";
import rightDown from "../components/rightDown";
import {
  Video,
  VideoDtail,
  CommentsInfo,
  SaveComment,
  Progress,
  Videoprogress,
  billing,
  levelContent,
  VideoError,
  Guess,
  knowledgeVideo,
  questionVideo,
  knowledgeDoc
} from "@/api/index";
export default {
  //
  components: {
    rightDown,
  },
  data() {
    return {
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      list: [
        { id: 1, name: "问老师" },
        { id: 2, name: "课程目录" },
      ],
      index: 1,
      video_list: [],
      video_index: 0,
      video_detail: {}, //视频详情
      comment_list: [], //评论列表
      value: "",
      time_c: 0,
      chapter_id: "",
      v_id: 0,
      memorytime: 0, //记忆播放
      hackReset: true,
      realList: [],
      player: null,
      adInfo: "",
      addClassContent: "",
      GuessList:[],
      docDetails:'',
    };
  },
  // 页面加载
  created() {
    this.getAdInfo();
    this.joinClass();
    this.GuessM();
    if(!this.$route.query.isBack) this.knowledgeDocM();
  },
  mounted() {
    this.chapter_id = sessionStorage.getItem("id");
    this.v_id = sessionStorage.getItem("id");
    this.requery(sessionStorage.getItem("id"));
    // this.memory();

    this.realList = sessionStorage.getItem("realList");
    this.videoDtail(this.v_id);
  },
  methods: {
    knowledgeDocM(){
      knowledgeDoc(this.$route.query.knowledge_id||this.$route.query.chapter_id).then(res=>{
        console.log(res)
        if(res.code!=1) return this.docDetails= ''
        else this.docDetails = res.data
      })
    },
    goTest(){
      this.$router.push({
        path: "workZsdxx",
        query: {
          subject_id: this.$route.query.subject_id,
          chapter_id: this.$route.query.chapter_id,
          knowledge_id:this.$route.query.knowledge_id,
          type: this.$route.query.type,
          vtype: this.$route.query.vtype,
          is_zsd:1,
          course_id: this.$route.query.course_id,
          k_id: this.$route.query.k_id,
          rule_tag: this.$route.query.rule_tag,
          course_chapter_id:this.$route.query.course_chapter_id,
        }
      });
    },
    goJY(){
      this.$router.push({
        path: "readJy",
        query: {
          course_id: this.$route.query.course_id,
          k_id: this.$route.query.k_id,
          rule_tag: this.$route.query.rule_tag,
          course_chapter_id:this.$route.query.course_chapter_id,
          subject_id: this.$route.query.subject_id,
          chapter_id: this.$route.query.chapter_id,
          knowledge_id:this.$route.query.knowledge_id||this.$route.query.chapter_id,
          isLoad:1
        }
      });
    },
    GuessM(){
      Guess({course_id:this.$route.query.course_id}).then(res=>{
        this.GuessList = res
      })
    },
    requery(id) {
      Video(id).then((res) => {
        // console.log(res);
        this.video_list = res;
      });
    },
    // 加入班群
    joinClass() {
      levelContent(this.$route.query.course_id, 13).then((res) => {
        //this.v_id
        // console.log(res)
        this.addClassContent = res;
      });
    },
    // 广告
    getAdInfo() {
      billing(9, this.$route.query.course_id).then((res) => {
        if (res.length > 0) this.adInfo = res[0];
      });
    },
    videoDtail(id) {
      let that = this
      return new Promise(function(resolve,reject){
        if(that.$route.query.vtype==2||that.$route.query.knowledge_id){
          knowledgeVideo(that.$route.query.knowledge_id).then(res=>{
            console.log(1111111111111,res);
            that.video_detail = res.data;
            if (that.player==null) {
              that.memory(id);
              that.playback( that.video_detail.sign.video_video_id, that.video_detail.sign.playAuth, that.video_detail.video_thumb, that.video_detail.is_encrypt, that.video_detail.sign.MtsHlsUriToken);

              console.log(1);
            }else{
              that.player.replayByVidAndPlayAuth(that.video_detail.sign.video_video_id, that.video_detail.sign.playAuth, that.video_detail.video_thumb, that.video_detail.is_encrypt, that.video_detail.sign.MtsHlsUriToken);
              let time = localStorage.getItem(that.video_detail.sign.video_video_id);
              console.log(2);
            }
            resolve()
          })
        }else{
          //  if(that.$route.query.vtype==1)
          questionVideo(that.$route.query.course_id).then(res=>{
            console.log(res);
            that.video_detail = res.data;
            if (that.player==null) {
              that.memory(id);
              that.playback( that.video_detail.sign.video_video_id, that.video_detail.sign.playAuth, that.video_detail.video_thumb, that.video_detail.is_encrypt, that.video_detail.sign.MtsHlsUriToken);

              console.log(1);
            }else{
              that.player.replayByVidAndPlayAuth(that.video_detail.sign.video_video_id, that.video_detail.sign.playAuth, that.video_detail.video_thumb, that.video_detail.is_encrypt, that.video_detail.sign.MtsHlsUriToken);
              let time = localStorage.getItem(that.video_detail.sign.video_video_id);
              console.log(2);
            }
            that.requery(sessionStorage.getItem("id"));
            resolve()
          })
        }
        // else{
        //   VideoDtail(id).then(res => {
        //     console.log(res);
        //     if (res.data.code == 400) {
        //       alert("视频不存在");
        //     } else {
        //       that.video_detail = res.data.data;

        //       if (that.player==null) {
        //         that.memory(id);
        //         that.playback( that.video_detail.sign.video_video_id, that.video_detail.sign.playAuth, that.video_detail.video_thumb, that.video_detail.is_encrypt, that.video_detail.sign.MtsHlsUriToken);

        //         console.log(1);
        //       }else{
        //         console.log(2);

        //         that.player.replayByVidAndPlayAuth(that.video_detail.sign.video_video_id, that.video_detail.sign.playAuth, that.video_detail.video_thumb, that.video_detail.is_encrypt, that.video_detail.sign.MtsHlsUriToken);
        //         let time = localStorage.getItem(that.video_detail.sign.video_video_id);
        //         //  this.player.seek(10)
        //       }
        //       // this.commentsInfo(res.data.data.video_id, "Video");
        //       resolve()
        //     }
        //   });
        // }
        
      })
    },
    // 评论
    commentsInfo(id, type) {
      CommentsInfo(id, type).then((res) => {
        this.comment_list = res.data.data.comments;
      });
    },
    // 发送评论
    saveComment(obj) {
      SaveComment(obj).then((res) => {
        console.log(res);
        if (res.status == 200) {
          this.$message({
            message: res.data.data,
            type: "success",
          });
          this.commentsInfo(this.video_detail.video_id, "Video");
        } else {
          this.$message.error(res.data.data);
        }
      });
    },
    close_click() {
      this.$router.go(-1);
    },
    // 回放
    saveTime(memoryPlay) {
      // console.log(memoryPlay.getCurrentTime());
      //  localStorage.setItem('time',memoryPlay.getCurrentTime())
    },
    getTime(memoryPlay) {
      let time = this.memorytime;
      // let time = localStorage.getItem(this.video_detail.sign.video_video_id);
      return time;
    },
    playback(video_id, playAuth, video_thumb, is_encrypt, MtsHlsUriToken) {
      let _this = this;
      if (this.player == null) {
        this.player = new Aliplayer(
          {
            id: "J_prismPlayer", // 容器id
            autoplay: true, // 是否自动播放
            width: "100%", // 播放器宽度
            height: "575px", // 播放器高度
            showBuffer: false,
            playsinline: true,
            preload: true,
            useH5Prism: true,
            useFlashPrism: false,
            x5_video_position: "top", // 指定视频播放位置,top,center
            x5_type: "noh5", // 声明启用同层h5播放器
            x5_fullscreen: true, // 声明视频播放时是否进入到 TBS 的全屏模式，支持的值：true
            x5_orientation: "portraint", //声明 TBS 播放器支持的方向，可选值：landscape:横屏）portraint:竖屏:跟随手机自动旋转
            // source:
            // "http://cloud.video.taobao.com/play/u/2554695624/p/1/e/6/t/1/fv/102/28552077.mp4", //视频地址
            vid: video_id,
            playauth: playAuth,
            cover: video_thumb, //播放器封面图
            // encryptType: is_encrypt,
            playConfig:{MtsHlsUriToken: MtsHlsUriToken},
            components: [
              {
                name: "RateComponent",
                type: AliPlayerComponent.RateComponent,
              },
              {
                name: "MemoryPlayComponent",
                type: AliPlayerComponent.MemoryPlayComponent,
                /* Set the first parameter to true to enable auto play. The default is false. */
                args: [false, _this.getTime, _this.saveTime],
              },
            ],
          },
          function (player) {
            //  player.seek(_this.memorytime);
          }
        );
      }
      var player = this.player;
      // player.on("ready", function(e) {
      //   console.log("自动播放");
      //   player.play();
      //   player.seek(_this.memorytime);
      // });
      player.on("play", function (e) {
        console.log("开始");
        _this.getLastTime();
      });
      player.on("timeupdate", function (e) {
        _this.time_c = player.getCurrentTime();
        // console.log(player.getCurrentTime());
      });
      player.on("pause", function (e) {
        console.log("暂停");
        clearInterval(_this.timer);
      });

      player.on("ended", function (e) {
        console.log("结束");
        clearInterval(_this.timer);
        let progressobj = {};
        progressobj.chapter_id = _this.chapter_id;
        progressobj.progress = 10;
        progressobj.previous = _this.time_c;
        Progress(progressobj).then((res) => {
          console.log(res);
        });
      });

      player.on("error", function (e) {
        if (e && "paramData" in e && "error_code" in e.paramData && "error_msg" in e.paramData && "mediaId" in e.paramData) {
            var obj = {
              error_code: e.paramData.error_code,
              error_msg: e.paramData.error_msg,
              video_id: e.paramData.mediaId
            };
            console.log("obj",obj);
            VideoError(obj).then((res) => {
            });
        }
      });

      // 以下为单击暂停/播放功能
      // var _video = document.querySelector("video");
      // player.on("play", function(e) {
      //   _video.removeEventListener("click", play);
      //   _video.addEventListener("click", pause);
      // });
      // player.on("pause", function(e) {
      //   _video.removeEventListener("click", pause);
      //   _video.addEventListener("click", play);
      // });
      // _video._firstFullscreen = true;
      // player.on("requestFullScreen", function(e) {
      //   if (_video._firstFullscreen) {
      //     player.cancelFullScreen();
      //     _video._firstFullscreen = false;
      //   } else {
      //     _video.addClass("center");
      //   }
      // });
      // player.on("cancelFullScreen", function(e) {
      //   _video.removeClass("center");
      // });

      // player.on("requestFullScreen", function(e) {
      //   _video.adjustLayout(true);
      //   player.cancelFullScreen();
      // });

      // // player.tag.addEventListener("x5videoexitfullscreen", function(e) {
      // //   if (WeixinJSBridge) WeixinJSBridge.call("closeWindow");
      // // });

      // function play() {
      //   if (player) player.play();
      // }

      // function pause() {
      //   if (player) player.pause();
      // }
    },

    chaunge_click(id) {
      this.index = id;
    },
    chuange_video(id,item) {
      if(item.is_lock==0) return
      if(item.id==this.$route.query.knowledge_id) return

      sessionStorage.setItem("id", id);
      // location.reload();
      this.player.dispose();
      this.player = null;
      this.videoDtail(id);
      this.v_id = id;
      // this.$router.push({ path: "playback", query: { id:id } });
      this.$router.replace({ path: "playbackZsd", query: { knowledge_id:id,type:this.$route.query.type,vtype:this.$route.query.vtype,course_id:this.$route.query.course_id,chapter_id:this.$route.query.chapter_id } });
      location.reload();
    },
    // 发送评论
    save_click() {
      console.log(this.value);
      let obj = {};
      obj.source_id = this.video_detail.video_id;
      obj.source_type = "Video";
      obj.content = this.value;
      if (this.value == "") {
      } else {
        this.saveComment(obj);
        this.value = "";
      }
    },
    getLastTime() {
      let _this = this;
      _this.timer = setInterval(function () {
        let progressobj = {};
        progressobj.chapter_id = _this.chapter_id;
        progressobj.progress = 10;
        progressobj.previous = _this.time_c;
        Progress(progressobj).then((res) => {
          console.log(res);
        });
      }, 10000);
    },
    // memory播放
    memory(id) {
      let _this = this;
      Videoprogress(id).then((res) => {
        console.log(res);
        this.memorytime = res.data.data.previous;
        // if (res.status == 200) {
        //   this.memorytime = res.data.data.previous;
        //   this.videoDtail(_this.v_id);
        // } else {
        //   this.memorytime = 0;
        //   this.videoDtail(_this.v_id);
        // }
      });
    },
    getRoutePath() {
      let realList = this.$route.meta.routeList;
      console.log(realList, "路由");
      sessionStorage.setItem("realList", realList);
    },
    billing_click(url) {
      window.location.href = url;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.realList = to.meta.routeList;
    });
  },
  destroyed() {
    // console.log("关闭");
    //如果定时器在运行则关闭
    let _this = this;
    clearInterval(_this.timer);
  },
  beforeRouteLeave(to, from, next) {
    console.log(to,from)
    if (to.path == "/workZsdxx") {
      to.meta.keepAlive = true;
      from.meta.keepAlive=false
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },





};
</script>
<style lang="scss" scoped>
.main_mfd {
  padding-bottom: 100px;
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 188px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: rgba(250, 220, 30, 1);
      }
    }
    .content_box_r {
      // width: 1134px;
      width: 100%;
      float: right;
      .video {
        float: left;
        width: 1025px;
        .title {
          padding: 16px 42px;
          background-color: #fff;
          font-size: 20px;
          font-weight: 500;
          color: rgba(43, 43, 43, 1);
        }
        .billing {
          width: 100%;
          cursor: pointer;
          img {
            width: 100%;
          }
        }
      }
      .directory {
        float: right;
        width: 313px;
        height: 630px;
        overflow-y: scroll;
        border: 1px solid rgba(238, 238, 238, 1);
        .directory_title {
          padding: 23px 0 14px 16px;
          background-color: #fff;
          font-size: 20px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
          span {
            float: left;
            display: block;
            width: 6px;
            height: 24px;
            background: rgba(250, 220, 30, 1);
            margin-right: 8px;
          }
        }
        .directory_content {
          .directory_list {
            padding: 20px 28px;
            border-bottom: 1px solid #eee;
          }
          .active {
            background: rgba(0, 69, 96, 0.08);
          }
        }
      }
      /*修改滚动条样式*/
      .directory::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        /**/
      }
      .directory::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
      }
      .directory::-webkit-scrollbar-thumb {
        background: #fadc1e;
        border-radius: 10px;
      }
      .directory::-webkit-scrollbar-thumb:hover {
        background: #333;
      }
      .directory::-webkit-scrollbar-corner {
        background: #179a16;
      }
      //   提问
      .put_box {
        width: 1025px;
        background-color: #fff;
        .put_sb {
          padding: 32px;
          width: 100%;
          float: left;
          border-bottom: 1px solid #eee;
          .put_title {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 19px;
            line-height: 30px;
            span {
              float: left;
              width: 6px;
              height: 30px;
              background: rgba(250, 220, 30, 1);
              border-radius: 3px;
              margin-right: 8px;
            }
          }
          .put_content {
            .el-input {
              float: left;
              width: 624px !important;
            }
            .btn {
              cursor: pointer;
              float: left;
              width: 85px;
              height: 33px;
              background: rgba(250, 220, 30, 1);
              border-radius: 4px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              text-align: center;
              line-height: 33px;
              margin-left: 12px;
            }
          }
        }
        .put_sb_bottom {
          height: 270px;
          width: 100%;
          overflow-y: scroll;
          float: left;
          .put_sb_bottom_box {
            padding: 32px 0px 32px 52px;

            .put_sb_list {
              margin-bottom: 33px;
              .put_sb_list_l {
                float: left;
                margin-right: 10px;
                img {
                  width: 39px;
                  height: 39px;
                  border-radius: 50%;
                }
              }
              .put_sb_list_r {
                float: left;
                .name {
                  font-size: 12px;
                  font-weight: 500;
                  color: rgba(34, 34, 34, 1);
                  margin-bottom: 5px;
                }
                .time {
                  font-size: 12px;
                  font-weight: 500;
                  color: rgba(187, 187, 187, 1);
                  margin-bottom: 13px;
                }
                .text {
                  width: 583px;
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(102, 102, 102, 1);
                }
              }
            }
          }
        }
        /*修改滚动条样式*/
        .put_sb_bottom::-webkit-scrollbar {
          // display: none;
        }
        .put_sb_bottom::-webkit-scrollbar {
          width: 10px;
          height: 10px;
          /**/
        }
        .put_sb_bottom::-webkit-scrollbar-track {
          background: rgb(239, 239, 239);
          border-radius: 2px;
        }
        .put_sb_bottom::-webkit-scrollbar-thumb {
          background: #fadc1e;
          border-radius: 10px;
        }
        .put_sb_bottom::-webkit-scrollbar-thumb:hover {
          background: #333;
        }
        .put_sb_bottom::-webkit-scrollbar-corner {
          background: #179a16;
        }
      }
    }
  }
}
.main_kjc {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 188px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: #0cd56d;
      }
    }
    .content_box_r {
      // width: 1134px;
      width: 100%;
      float: right;
      .video {
        float: left;
        width: 1025px;
        .title {
          padding: 16px 42px;
          background-color: #fff;
          font-size: 20px;
          font-weight: 500;
          color: rgba(43, 43, 43, 1);
        }
        .billing {
          width: 100%;
          img {
            width: 100%;
          }
        }
      }
      .directory {
        float: right;
        width: 313px;
        height: 497px;
        overflow-y: scroll;
        border: 1px solid rgba(238, 238, 238, 1);
        .directory_title {
          padding: 23px 0 14px 16px;
          background-color: #fff;
          font-size: 20px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
          span {
            float: left;
            display: block;
            width: 6px;
            height: 24px;
            background: #0cd56d;
            margin-right: 8px;
          }
        }
        .directory_content {
          .directory_list {
            padding: 20px 28px;
            border-bottom: 1px solid #eee;
          }
          .active {
            background: rgba(0, 69, 96, 0.08);
          }
        }
      }
      /*修改滚动条样式*/
      .directory::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        /**/
      }
      .directory::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
      }
      .directory::-webkit-scrollbar-thumb {
        background: #0cd56d;
        border-radius: 10px;
      }
      .directory::-webkit-scrollbar-thumb:hover {
        background: #333;
      }
      .directory::-webkit-scrollbar-corner {
        background: #179a16;
      }
      //   提问
      .put_box {
        width: 1025px;
        background-color: #fff;
        .put_sb {
          padding: 32px;
          width: 100%;
          float: left;
          border-bottom: 1px solid #eee;
          .put_title {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 19px;
            line-height: 30px;
            span {
              float: left;
              width: 6px;
              height: 30px;
              background: rgba(250, 220, 30, 1);
              border-radius: 3px;
              margin-right: 8px;
            }
          }
          .put_content {
            .el-input {
              float: left;
              width: 624px !important;
            }
            .btn {
              cursor: pointer;
              float: left;
              width: 85px;
              height: 33px;
              background: rgba(250, 220, 30, 1);
              border-radius: 4px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              text-align: center;
              line-height: 33px;
              margin-left: 12px;
            }
          }
        }
        .put_sb_bottom {
          height: 270px;
          width: 100%;
          overflow-y: scroll;
          float: left;
          .put_sb_bottom_box {
            padding: 32px 0px 32px 52px;

            .put_sb_list {
              margin-bottom: 33px;
              .put_sb_list_l {
                float: left;
                margin-right: 10px;
                img {
                  width: 39px;
                  height: 39px;
                  border-radius: 50%;
                }
              }
              .put_sb_list_r {
                float: left;
                .name {
                  font-size: 12px;
                  font-weight: 500;
                  color: rgba(34, 34, 34, 1);
                  margin-bottom: 5px;
                }
                .time {
                  font-size: 12px;
                  font-weight: 500;
                  color: rgba(187, 187, 187, 1);
                  margin-bottom: 13px;
                }
                .text {
                  width: 583px;
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(102, 102, 102, 1);
                }
              }
            }
          }
        }
        /*修改滚动条样式*/
        .put_sb_bottom::-webkit-scrollbar {
          // display: none;
        }
        .put_sb_bottom::-webkit-scrollbar {
          width: 10px;
          height: 10px;
          /**/
        }
        .put_sb_bottom::-webkit-scrollbar-track {
          background: rgb(239, 239, 239);
          border-radius: 2px;
        }
        .put_sb_bottom::-webkit-scrollbar-thumb {
          background: #fadc1e;
          border-radius: 10px;
        }
        .put_sb_bottom::-webkit-scrollbar-thumb:hover {
          background: #333;
        }
        .put_sb_bottom::-webkit-scrollbar-corner {
          background: #179a16;
        }
      }
    }
  }
}


.recommend{
  width: 100%;
  background: white;
  .titleBox{
    height: 76px;
    line-height: 76px;
    padding-left: 64px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    position: relative;
    border-bottom: 1px solid #eeeeee;
    &::before{
      position: absolute;
      content: '';
      left:32px;
      top: 22px;
      width: 8px;
      height: 30px;
      background: #FADC1E;
    }
  }
  .content{
    padding: 28px 64px;
    white-space: nowrap;
    overflow-x: auto;
    a{
      display: inline-block;
      width: 381px;
      height: 228px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #DDDDDD;
      box-sizing: border-box;
      padding: 14px 22px;
      margin-right: 24px;
      .title{
        font-size: 20px;
        font-family: MicrosoftYaHeiSemibold;
        color: #000000;
        padding-right: 76px;
        height: 60px;
        line-height: 30px;
        overflow: hidden;
        white-space: normal;
      }
      .iconBox{
        min-height: 54px;
        margin-top: 25px;
        overflow: hidden;
        .icon{
          width: 48px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          margin-right: 14px;
          float: left;
          img{
            width: 35px;
            height: 35px;
            border-radius: 50%;
          }
          span{
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            margin-top: 4px;
          }
        }
      }
      .bottomBox{
          margin-top: 27px;
          overflow: hidden;
          .price{
            font-size: 18px;
            font-weight: 500;
            color: #FF3356;
            margin-right: 24px;
            float:left;
          }
          .tip{
            font-size: 12px;
            font-weight: 500;
            color: #AAAAAA;
            float:left;
            position: relative;
            top: 5px;
          }
          button{
            cursor: pointer;
            float: right;
            width: 104px;
            height: 34px;
            background: #FE4C4B;
            border-radius: 17px;
            font-size: 14px;
            text-align: center;
            border: 0;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      
    }
  }

}

.bottom2{
  background: white;
  margin-top: 24px;
  padding: 32px;
  button{
    &:first-of-type{
      background: #169BD5;
      color: white;
    }
    &:last-of-type{
      background: #FCE025;
      color: black;
    }
    
  }
}

</style>
<style>
.prism-player .prism-big-play-btn {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);
}
.prism-player .prism-controlbar {
  background: rgba(0, 0, 0, 0.5);
}
</style>
